import { render, staticRenderFns } from "./TrainingChart.vue?vue&type=template&id=13385b52&scoped=true"
import script from "./TrainingChart.vue?vue&type=script&lang=js"
export * from "./TrainingChart.vue?vue&type=script&lang=js"
import style0 from "./TrainingChart.vue?vue&type=style&index=0&id=13385b52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13385b52",
  null
  
)

export default component.exports